import { Autocomplete, IconButton, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FIELD_TYPES, TABLE_FIELD_CONSTRAINTS } from '../../../utility/constants'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { listDataService } from '../../../services/listDataService'
import DeleteIcon from '@mui/icons-material/Delete'

export const COMPARATIVE = ['lte', 'lt', 'gte', 'gt', 'eq']

const TableFieldConstraintItemEditUI = ({
  fields,
  constraintItem,
  updateConstraint = (updated) => {},
  pivotFields,
  onDelete,
  selectedField,
}) => {
  const { user } = useAuthContext()
  const [listItems, setListItems] = useState([])

  useEffect(() => {
    ;(async () => {
      if (
        selectedField?.data_structure == FIELD_TYPES.LIST ||
        selectedField?.data_structure == FIELD_TYPES.LIST_MULTI
      ) {
        const listItemsData = await listDataService.getData(user, selectedField?.list_id)
        setListItems(listItemsData.data)
      }
    })()
  }, [selectedField])

  const getSelectedField = (fieldId, fields) => {
    const field = fields?.find((it) => it.id == fieldId)
    if (field) {
      return { value: field, label: field?.field_template_name }
    } else {
      return null
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          columnGap: 8,
          marginTop: 12,
          marginBottom: 10,
          alignItems: 'center',
        }}
      >
        <Autocomplete
          value={
            constraintItem?.constraint
              ? { value: constraintItem?.constraint, label: constraintItem?.constraint }
              : null
          }
          id="autocomplete-operator"
          options={Object.entries(TABLE_FIELD_CONSTRAINTS).map(([key, value]) => {
            return { value, label: key }
          })}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Constraint" />}
          onChange={(e, v) => {
            updateConstraint({
              ...constraintItem,
              constraint: v?.value || null,
            })
          }}
          size="small"
        />

        <Autocomplete
          value={getSelectedField(constraintItem.related_subfield_template_id, fields)}
          id="autocomplete-field"
          options={fields.map((it) => {
            return { value: it, label: it.field_template_name }
          })}
          sx={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Related Field Value (Optional)  " />
          )}
          onChange={(e, v) => {
            updateConstraint({
              ...constraintItem,
              related_subfield_template_id: v?.value?.id || null,
              constant_value: null,
            })
          }}
          size="small"
          disabled={!COMPARATIVE.includes(constraintItem?.constraint)}
        />

        <Typography variant="p" style={{ fontSize: 12 }}>
          OR
        </Typography>

        <TextField
          value={constraintItem.constant_value}
          id="outlined-basic"
          label="Value (Optional)"
          variant="outlined"
          onChange={(e) =>
            updateConstraint({
              ...constraintItem,
              constant_value: e.target.value || null,
              related_subfield_template_id: null,
            })
          }
          size="small"
          disabled={!COMPARATIVE.includes(constraintItem?.constraint)}
        />

        <Autocomplete
          id="autocomplete-pivot-field"
          value={getSelectedField(constraintItem.pivot_field_template_id, pivotFields)}
          options={pivotFields.map((it) => {
            return { value: it, label: it.field_template_name }
          })}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Pivot Field" color="secondary" />}
          onChange={(e, v) => {
            updateConstraint({
              ...constraintItem,
              pivot_field_template_id: v?.value.id || null,
            })
          }}
          size="small"
        />

        <IconButton onClick={() => onDelete(constraintItem.id)}>
          <DeleteIcon size="small" />
        </IconButton>
      </div>
    </>
  )
}

export default TableFieldConstraintItemEditUI
